/**
 * useNativeBrowser
 *
 * Su piattaforme native (iOS/Android) apre URL nel browser di sistema
 * tramite @capacitor/browser invece di window.location.href.
 * Su web usa il comportamento standard del browser.
 */

import { Capacitor } from '@capacitor/core';
import { logger } from '@deskbay/shared';

/**
 * Apre un URL esterno.
 * - Native: usa @capacitor/browser (browser di sistema, con back button)
 * - Web: usa window.location.href (redirect normale)
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url, presentationStyle: 'fullscreen' });
    } catch (err) {
      logger.capacitor.warn('Fallback to window.location', 'useNativeBrowser', { error: err });
      window.location.href = url;
    }
  } else {
    window.location.href = url;
  }
}

/**
 * Apre un URL in una finestra separata (solo web).
 * Su native usa sempre openExternalUrl.
 */
export async function openExternalUrlNewTab(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    return openExternalUrl(url);
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
